import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { FeatureFlagValue } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagResolver implements Resolve<{ [key :string] :boolean }> {
  constructor(private featureToggleService :FeatureToggleService) {}

  resolve(route :ActivatedRouteSnapshot) :{ [key :string] :boolean } {
    const featureFlagKeys :{ [key :string] :FeatureFlagValue } =
      route.data.featureFlagKeys || {};
    const featureFlags :{ [key :string] :boolean } = {};

    for (const customKey in featureFlagKeys) {
      if (featureFlagKeys.hasOwnProperty(customKey)) {
        const enumValue = featureFlagKeys[customKey];
        featureFlags[customKey] =
          this.featureToggleService.featureEnabled(enumValue);
      }
    }

    return featureFlags;
  }
}
